import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiUsers, FiPlay } = FiIcons;

const NextActions = () => {
  const actions = [
    {
      icon: FiCheckCircle,
      title: "Board signs off",
      description: "on Creatica scope & service budget."
    },
    {
      icon: FiUsers,
      title: "Set internal pledge quotas",
      description: "per phase (see top table) and assign board \"gift officers.\""
    },
    {
      icon: FiPlay,
      title: "Launch Phase A",
      description: "– Documentary shoot booked for 18 Aug, premiere private screener 10 Sep."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-black mb-12 text-center">Next Actions</h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {actions.map((action, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="bg-[#FF5F1F] text-white rounded-full p-3 flex-shrink-0">
                  <SafeIcon icon={action.icon} className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-black mb-2">{index + 1}. {action.title}</h3>
                  <p className="text-gray-600">{action.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-lg p-6 shadow-sm border border-gray-100">
          <p className="text-sm text-gray-600 italic text-center">
            Ready to proceed? We can lock production dates and issue a formal Statement of Work within 24 hours.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NextActions;